import React from "react";
import { Button, Dialog, DialogTitle } from "@mui/material";
import { is_small_medium_screen } from "../utils/constant";

/**
 * DeleteConfirmation Component
 *
 * This component renders a confirmation dialog used to confirm deletion or critical actions.
 * It supports dynamic title text, customizable buttons, and a loading state during action confirmation.
 *
 * Props:
 * - open (boolean): Controls whether the dialog is open.
 * - isLoading (boolean): Shows a loading state on the confirm button.
 * - setOpen (function): Setter to toggle dialog open state.
 * - handleAgree (function): Function called when user confirms the action.
 * - title (string): Optional title for the confirmation dialog.
 * - handleClose (function): Function to handle custom closing behavior.
 * - setRowData (function): Optional function to reset associated row data.
 * - setRowDataID (function): Optional function to reset the row data ID.
 * - Btn_Title (string): Optional custom title for the confirm button.
 *
 * Responsive Behavior:
 * - Adjusts max width of the dialog based on screen size (uses `is_small_medium_screen`).
 */

function DeleteConfirmation({
  open,
  isLoading,
  setOpen,
  handleAgree,
  title,
  handleClose,
  setRowData,
  setRowDataID,
  Btn_Title,
}) {
  const handleCloseDialog = () => {
    handleClose();
    setOpen(false);
  };

  return (
    <>
      <Dialog
        onTransitionExited={() => {
          setRowData && setRowData({});
          setRowDataID && setRowDataID("");
        }}
        open={open}
        style={{
          zIndex: 9999999999,
        }}
        sx={{
          zIndex: 9999999999,
        }}
        onClose={handleCloseDialog}
        PaperProps={{
          style: {
            boxShadow: "none",
            maxWidth: is_small_medium_screen ? "100%" : 450,
            borderRadius: "20px",
            margin: "10px",
            zIndex: 9999999999,
          },
        }}
      >
        <DialogTitle>
          <div className="text-center p-2 pt-3 pb-3">
            <div>
              <p className="mb-0 delete-confirm-text">
                {title ? title : "Are you sure you want to take this action?"}
              </p>
            </div>
            <div className="d-flex justify-content-center gap-3 ">
              <Button
                variant="outlined"
                className="capitalized delete-cancel-button font-family"
                onClick={handleCloseDialog}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={isLoading}
                onClick={handleAgree}
                className="capitalized delete-confirm-button font-family"
              >
                {isLoading ? "Loading..." : Btn_Title ? Btn_Title : "Delete"}
              </Button>
            </div>
          </div>
        </DialogTitle>
      </Dialog>
    </>
  );
}

export default DeleteConfirmation;
